import * as tslib_1 from "tslib";
import { State, Action, Store, Selector } from '@ngxs/store';
import { filter, map, take, distinctUntilKeyChanged } from 'rxjs/operators';
import { clone } from 'lodash';
var category = 'Header';
var ShowSelector = /** @class */ (function () {
    function ShowSelector(show) {
        this.show = show;
    }
    ShowSelector.type = "[" + category + "] ShowSelector";
    return ShowSelector;
}());
export { ShowSelector };
var ChangeLocation = /** @class */ (function () {
    function ChangeLocation(loc) {
        this.loc = loc;
    }
    ChangeLocation.type = "[" + category + "] ChangeLocation";
    return ChangeLocation;
}());
export { ChangeLocation };
var HeaderState = /** @class */ (function () {
    function HeaderState(store) {
        this.store = store;
    }
    HeaderState_1 = HeaderState;
    HeaderState.selectorShown = function (state) {
        return state.selectorShown;
    };
    HeaderState.currentLocation = function (state) {
        return state.location;
    };
    HeaderState.prototype.showSelector = function (ctx, action) {
        ctx.patchState({
            selectorShown: action.show,
        });
    };
    HeaderState.prototype.changeLocation = function (ctx, action) {
        localStorage.setItem('location', action.loc.id.toString());
        ctx.patchState({
            location: action.loc,
        });
    };
    HeaderState.prototype.getLocation = function () {
        return this.store.select(HeaderState_1.currentLocation).pipe(filter(function (loc) { return !!loc; }), map(function (loc) { return clone(loc); }), take(1));
    };
    HeaderState.prototype.onChangeLocation = function () {
        return this.store.select(HeaderState_1.currentLocation).pipe(filter(function (loc) { return !!loc; }), distinctUntilKeyChanged('id'), map(function (loc) { return clone(loc); }));
    };
    var HeaderState_1;
    tslib_1.__decorate([
        Action(ShowSelector),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, ShowSelector]),
        tslib_1.__metadata("design:returntype", void 0)
    ], HeaderState.prototype, "showSelector", null);
    tslib_1.__decorate([
        Action(ChangeLocation),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, ChangeLocation]),
        tslib_1.__metadata("design:returntype", void 0)
    ], HeaderState.prototype, "changeLocation", null);
    tslib_1.__decorate([
        Selector([HeaderState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], HeaderState, "selectorShown", null);
    tslib_1.__decorate([
        Selector([HeaderState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], HeaderState, "currentLocation", null);
    HeaderState = HeaderState_1 = tslib_1.__decorate([
        State({
            name: 'header',
            defaults: {
                selectorShown: false,
                location: null,
            },
        }),
        tslib_1.__metadata("design:paramtypes", [Store])
    ], HeaderState);
    return HeaderState;
}());
export { HeaderState };
